import { makeStyles, SvgIcon } from '@material-ui/core';
import React from 'react';

type Props = {
  disabled?: boolean;
};

const DragHandle: React.FC<Props> = ({ disabled, ...props }) => {
  const classes = useStyles();

  return (
    <div
      className={[classes.dragHandle, disabled ? classes.disabled : ''].join(
        ' ',
      )}
      title={disabled ? undefined : 'Drag to reorder list'}
      {...props}
    >
      <SvgIcon width="8" height="11" viewBox="0 0 8 11" fill="none">
        <path
          d="M2.25771 0.979004C2.46083 0.979004 2.63271 1.05713 2.77333 1.21338C2.92958 1.354 3.00771 1.52588 3.00771 1.729V3.229C3.00771 3.43213 2.92958 3.61182 2.77333 3.76807C2.63271 3.90869 2.46083 3.979 2.25771 3.979H0.757707C0.554582 3.979 0.374895 3.90869 0.218645 3.76807C0.0780196 3.61182 0.00770712 3.43213 0.00770712 3.229V1.729C0.00770712 1.52588 0.0780196 1.354 0.218645 1.21338C0.374895 1.05713 0.554582 0.979004 0.757707 0.979004H2.25771ZM2.25771 4.729C2.46083 4.729 2.63271 4.80713 2.77333 4.96338C2.92958 5.104 3.00771 5.27588 3.00771 5.479V6.979C3.00771 7.18213 2.92958 7.36182 2.77333 7.51807C2.63271 7.65869 2.46083 7.729 2.25771 7.729H0.757707C0.554582 7.729 0.374895 7.65869 0.218645 7.51807C0.0780196 7.36182 0.00770712 7.18213 0.00770712 6.979V5.479C0.00770712 5.27588 0.0780196 5.104 0.218645 4.96338C0.374895 4.80713 0.554582 4.729 0.757707 4.729H2.25771ZM2.25771 8.479C2.46083 8.479 2.63271 8.55713 2.77333 8.71338C2.92958 8.854 3.00771 9.02588 3.00771 9.229V10.729C3.00771 10.9321 2.92958 11.104 2.77333 11.2446C2.63271 11.4009 2.46083 11.479 2.25771 11.479H0.757707C0.554582 11.479 0.374895 11.4009 0.218645 11.2446C0.0780196 11.104 0.00770712 10.9321 0.00770712 10.729V9.229C0.00770712 9.02588 0.0780196 8.854 0.218645 8.71338C0.374895 8.55713 0.554582 8.479 0.757707 8.479H2.25771ZM6.75771 0.979004C6.96083 0.979004 7.13271 1.05713 7.27333 1.21338C7.42958 1.354 7.50771 1.52588 7.50771 1.729V3.229C7.50771 3.43213 7.42958 3.61182 7.27333 3.76807C7.13271 3.90869 6.96083 3.979 6.75771 3.979H5.25771C5.05458 3.979 4.87489 3.90869 4.71864 3.76807C4.57802 3.61182 4.50771 3.43213 4.50771 3.229V1.729C4.50771 1.52588 4.57802 1.354 4.71864 1.21338C4.87489 1.05713 5.05458 0.979004 5.25771 0.979004H6.75771ZM6.75771 4.729C6.96083 4.729 7.13271 4.80713 7.27333 4.96338C7.42958 5.104 7.50771 5.27588 7.50771 5.479V6.979C7.50771 7.18213 7.42958 7.36182 7.27333 7.51807C7.13271 7.65869 6.96083 7.729 6.75771 7.729H5.25771C5.05458 7.729 4.87489 7.65869 4.71864 7.51807C4.57802 7.36182 4.50771 7.18213 4.50771 6.979V5.479C4.50771 5.27588 4.57802 5.104 4.71864 4.96338C4.87489 4.80713 5.05458 4.729 5.25771 4.729H6.75771ZM6.75771 8.479C6.96083 8.479 7.13271 8.55713 7.27333 8.71338C7.42958 8.854 7.50771 9.02588 7.50771 9.229V10.729C7.50771 10.9321 7.42958 11.104 7.27333 11.2446C7.13271 11.4009 6.96083 11.479 6.75771 11.479H5.25771C5.05458 11.479 4.87489 11.4009 4.71864 11.2446C4.57802 11.104 4.50771 10.9321 4.50771 10.729V9.229C4.50771 9.02588 4.57802 8.854 4.71864 8.71338C4.87489 8.55713 5.05458 8.479 5.25771 8.479H6.75771Z"
          fill="#0D374B"
        />
      </SvgIcon>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  disabled: {},
  dragHandle: {
    cursor: 'pointer',

    '& > *': {
      width: 8,
      height: 11,
      marginLeft: theme.spacing(1),
    },

    '&$disabled': {
      cursor: 'default',
    },

    '&$disabled > * path': {
      fill: theme.palette.grey[500],
    },
  },
}));

export default DragHandle;
